<template>
  <div class="time-suggestion">
    {{ time }}
  </div>
</template>

<script>
export default {
  name: 'TimeSuggestion',

  props: {
    time: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
